module.exports = __webpack_public_path__ + "static/media/atero-dash.134a2072.png";